import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TitleService } from '../../services/title.service';
import { Persona } from '../../models/persona.model';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';

@Component({
    selector: 'app-team',
    imports: [CommonModule, RouterModule],
    templateUrl: './team.component.html',
    styleUrl: './team.component.css'
})
export class TeamComponent {

  dipendenti: Array<Persona> =
  [
    {denominazione: "Matteo Sementilli", ruolo: "Personal Trainer - Istruttore di sala", nomeFoto: "matteo.jpg", linkInstagram: "https://www.instagram.com/matteo_sementilli_pt?igsh=MTB2YXVxMHgybjdkOA=="},
    {denominazione: "Rosa Zampetti", ruolo: "Personal Trainer - Istruttrice fitness", nomeFoto: "rosa.jpg", linkInstagram: "https://www.instagram.com/rosafittrainer?igsh=MWttdTNrazVmM2w3dQ=="},
    {denominazione: "Francesco Lombardo", ruolo: "Personal Trainer - Istruttore di sala", nomeFoto: "uomo.png", linkInstagram: "https://www.instagram.com/lombfra23?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="},
    {denominazione: "Jacopo D'Amico", ruolo: "Personal Trainer - Istruttore di sala", nomeFoto: "jack.jpg", linkInstagram: "https://www.instagram.com/jd_personaltraining?igsh=MWVocmxjMWFlZ2V2ag=="},
    {denominazione: "Alessandro Princi", ruolo: "Fisioterapista - Osteopata", nomeFoto: "princi.jpg", linkInstagram: "https://www.instagram.com/osteo_princi?igsh=MXR4MGplODJ0ZHBpcg=="},
    {denominazione: "Pietro Pasquariello", ruolo: "Nutrizionista", nomeFoto: "pasquariello.jpg", linkInstagram: "https://www.instagram.com/pietro_pasquariello?igsh=MTdpamR0enVjeXBjeQ=="},
    {denominazione: "Gianni Labarbuta", ruolo: "Istruttore Pilates", nomeFoto: "labarbuta.jpg", linkInstagram: "https://www.instagram.com/pilates_labb?igsh=dDl6Nm04a3J3enNs"},
    {denominazione: "Valerio Olivieri", ruolo: "Istruttrore Kickboxing", nomeFoto: "uomo.png", linkInstagram: ""},
    {denominazione: "Federica Peluso", ruolo: "Personal Trainer - Istruttrice fitness", nomeFoto: "donna.png", linkInstagram: ""},
    {denominazione: "Viola Spera", ruolo: "Istruttrice fitness", nomeFoto: "donna.png", linkInstagram: ""},
    {denominazione: "Monia Catena e Fabrizio Bellucci", ruolo: "Insegnanti Salsa e Bachata", nomeFoto: "catena.jpg", linkInstagram: "https://www.instagram.com/fabrizioemonia?igsh=MTNqbzI3YWllNG5pOA=="}
  ];

  constructor(public router: Router, private ts : TitleService) {
  }
  ngOnInit(){
    this.ts.titolo = "Il nostro team";
  }
}
